<template>
  <v-flex xs12> 
    <Diccionario :id_unit="this.idUnidad" :isPractice="true"/>
    <CardLectura 
    :image="require('@/assets/images/unit/practice/' + loadedLessons.imagen)"
    :textKr="loadedLessons.large_text_korean"
    :textEs="loadedLessons.large_text_spanish"
    />
    <v-btn
    round
    large
    router-link
    :to="`/practica/avanzada/${idUnidad}/ejercicio/practicaPregunta`"
    color="primary">
      CONTINUAR
    </v-btn>
  </v-flex>
</template>

<script>
import CardLectura from '../../../components/Practica/intermedio/CardLectura'
import { storeFirebase } from '../../../store/firebase'
export default {
  name: 'CardLeerAvanzado',
  props: ['idUnidad'],
  components: {
    CardLectura
  },
  created () {
    this.loadLessons()
  },
  computed: {
    loadedLessons () {
      const dataValues = storeFirebase.getters.loadedPracticeLessons
      const data = dataValues.filter(data => data.id_tipo_ejercicio == 9)
      return data[0]
    }
  },
  methods: {
    loadLessons () {
      const payload = {
        id_unit: Number(this.idUnidad),
        id_practice: 3
      }
      storeFirebase.dispatch("loadPracticeLessons", payload)
    }
  }
}
</script>
